import { useResolveColorTheme } from '@utils/useResolveColorTheme';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
  from {
    transform: rotate(0deg);
  }
`;

export const FullScreenContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background: ${() =>
    useResolveColorTheme({ light: '#ffffff', dark: '#7A7D8B' })};
  z-index: 100;

  svg {
    width: 5.438rem;
    height: 5.438rem;
    margin-bottom: 2.75rem;
    animation: ${rotate} 1.5s infinite linear;
  }
`;

export const Container = styled.section`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  svg {
    width: 5.438rem;
    height: 5.438rem;
    margin-bottom: 2.75rem;
    animation: ${rotate} 1.5s infinite linear;
  }

  h6 {
    text-align: center;
    line-height: 1.75rem;
    margin-bottom: 0.75rem;
    color: ${(props) => props.theme.gray6};
  }

  p {
    text-align: center;
    color: ${(props) => props.theme.gray5};
    line-height: 1.25rem;
  }
`;
